import classNames from 'classnames'
import { observer } from 'mobx-react-lite'
import moment from 'moment'

import { dmsState } from '@/app/store'

import Error from '../error.svg'

import style from './ImportHistory.module.scss'

export const ImportHistory = observer(() => {
    const STATUS_MAPPER: Record<string, string> = {
        // Error: 'Ошибка',
        ImportError: 'Ошибка импорта',
        SystemError: 'Системная ошибка',
        Success: 'Завершено',
        InProgress: 'Загрузка'
    }

    if (!dmsState.importHistory) {
        return null
    }

    return (
        <div className={style.container}>
            {dmsState.importHistory.map((log, idx) => {
                const { startedAt, login, status } = log
                return (
                    <div key={idx} className={style.historyWrapper}>
                        <div>
                            <span>{moment(startedAt).format('DD.MM.YYYY')}</span>
                        </div>
                        <div>
                            <span>{login}</span>
                        </div>
                        <div className={style.statusWrapper}>
                            {status.includes('ImportError') && idx === 0 && (
                                <div className={style.iconWrapper}>
                                    <Error
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => !dmsState.isFetching && dmsState.onGetLastErrors()}
                                    />
                                </div>
                            )}
                            <div
                                style={{ cursor: status.includes('ImportError') && idx === 0 ? 'pointer' : 'default' }}
                                className={classNames(style.statuses, style[status])}
                                onClick={() => {
                                    status.includes('ImportError') &&
                                        idx === 0 &&
                                        !dmsState.isFetching &&
                                        dmsState.onGetLastErrors()
                                }}
                            >
                                <span>{STATUS_MAPPER[status] || 'Не известно'}</span>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    )
})
